export const karolinaWaligora = {
    'mydrId': 'karolinawaligóra',
    'firstName': 'Karolina',
    'lastName': 'Waligóra',
    'profession': 'Psychoterapeutka psychoanalityczna',
    'avatar': 'karolina-waligora.webp',
    'slug': 'psychoterapeutka-karolina-waligora',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychoterapy', 'adult'],
        ['psychoterapy', 'children'],
    ]
}